import {
  Paper,
  Grid,
  Box,
  Menu,
  MenuItem,
  Badge,
  CircularProgress,
} from "@mui/material";
import { IconBtnBase, DataGrid, ResourcesList } from "Components";
import ExportProgressModal from "../../../../Components/ExportProgressModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { http } from "Utils/Http/Http";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { PARTICIPATIONLIST } from "Constants/QueriesKeys";
import { useHistory } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const styles = {
  tableSize: {
    height: 650,
    width: "100%",
  },
};

const ParticipationsPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [participationList, setParticipationList] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [exportJobId, setExportJobId] = useState(null);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [track, setTrack] = useState("");
  // const [searchPaticipation, setSearchPaticipation] = useState("")
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState();
  const spacing = 4;
  const [paginator1, setPaginator1] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [version, setVersion] = useState(4);
  const [awardParticipatCategories, setAwardParticipatCategories] =
    useState(null);

  const handleClose = () => setAnchorEl(null);

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const participationListRender = useQuery(
    [PARTICIPATIONLIST, { page, version, awardParticipatCategories }],
    () =>
      http
        .get(`api/v1/admin/participations`, {
          params: {
            page: page,
            limit: perPage,
            version,
            awardParticipatCategories,
          },
        })
        .then((response) => {
          return (
            (response,
              setParticipationList(response.data.data),
              setPaginator1(response?.data?.meta?.total)),
            setPerPage(response?.data?.meta?.per_page)
          );
        })
  );

  const participationCount = useQuery(
    [PARTICIPATIONLIST, version],
    () =>
      http
        .get(`api/v1/admin/participations/participations-count`, {
          params: {
            version,
          },
        })
        .then((response) => response.data.data),
    {
      keepPreviousData: true,
    }
  );

  const handleDownload = (track) => {
    // Show modal immediately
    setIsExporting(true);
    setShowProgressModal(true);
    setTrack(track);

    http
      .get(
        `api/v1/admin/participations/export?track=${track === "all" ? "" : track
        }&version=${version}&all=${track === "all" ? "1" : "0"}`
      )
      .then((res) => {
        console.log("=== EXPORT STARTED ===");
        console.log("Export response:", res.data);
        console.log("Time:", new Date().toISOString());
        setExportJobId(res.data.export_job_id);
        console.log("Modal opened, exportJobId:", res.data.export_job_id);
        handleClose();
      })
      .catch((error) => {
        console.error("Export error:", error);
        setIsExporting(false);
        setTrack("");
        setShowProgressModal(false);
      });
  };

  const handleExportComplete = () => {
    setIsExporting(false);
    setTrack("");
    setExportJobId(null);
  };

  const columns1 = [
    {
      field: "id",
      headerName: t("ID"),
      width: 100,
      editable: false,
    },
    {
      field: "full_name",
      headerName: "Full name",
      width: 230,
    },
    {
      field: "email",
      headerName: t("Email"),
      width: 250,
      editable: false,
    },
    {
      field: "track",
      headerName: t("Track"),
      width: 120,
      editable: false,
    },
    {
      field: "category",
      headerName: t("Award Category"),
      width: 150,
      editable: false,
    },
    {
      field: "country",
      headerName: t("Country"),
      width: 180,
      editable: false,
    },
    {
      field: "created_at",
      headerName: t("Date"),
      width: 120,
      editable: false,
      renderCell: (row) => row.row.created_at.split(" ")[0],
    },
    {
      field: "action",
      headerName: t("common.actions"),
      width: 100,
      editable: false,
      renderCell: (row) => {
        return (
          <div className="flex items-center">
            <IconBtnBase
              onClick={() =>
                history.push({
                  pathname: `participations/${row.id}`,
                  state: { detailsData: row?.row },
                })
              }
              size="large"
            >
              {/* <ExpandMoreIcon /> */}
              <VisibilityIcon />
            </IconBtnBase>
          </div>
        );
      },
    },
  ];
  console.log(participationCount.data);
  return (
    <>
      <ResourcesList
        headerProps={{
          title: t("participations"),
          EndSide: (
            <div className="flex">
              <IconBtnBase onClick={handleClickMenu} size="large">
                <CloudDownloadOutlinedIcon />
              </IconBtnBase>
              <Menu
                id="lock-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "lock-button",
                  role: "listbox",
                }}
              >
                <MenuItem
                  disabled={isExporting}
                  className="flex items-center gap-2"
                  onClick={() => {
                    handleDownload("video");
                  }}
                >
                  Download Video
                  {isExporting && track === "video" && (
                    <CircularProgress size={20} />
                  )}
                </MenuItem>
                <MenuItem
                  disabled={isExporting}
                  className="flex items-center gap-2"
                  onClick={() => {
                    handleDownload("photo");
                  }}
                >
                  Download Photo
                  {isExporting && track === "photo" && (
                    <CircularProgress size={20} />
                  )}
                </MenuItem>
                <MenuItem
                  disabled={isExporting}
                  className="flex items-center gap-2"
                  onClick={() => {
                    handleDownload("drawing");
                  }}
                >
                  Download Drawing
                  {isExporting && track === "drawing" && (
                    <CircularProgress size={20} />
                  )}
                </MenuItem>
                <MenuItem
                  disabled={isExporting}
                  className="flex items-center gap-2"
                  onClick={() => {
                    handleDownload("writing");
                  }}
                >
                  Download Writing
                  {isExporting && track === "writing" && (
                    <CircularProgress size={20} />
                  )}
                </MenuItem>
                <MenuItem
                  disabled={isExporting}
                  className="flex items-center gap-2"
                  onClick={() => {
                    handleDownload("all");
                  }}
                >
                  Download All
                  {isExporting && track === "all" && (
                    <CircularProgress size={20} />
                  )}
                </MenuItem>
              </Menu>
              <IconBtnBase
                onClick={() => {
                  console.log(participationListRender.refetch());
                }}
                size="large">
                <RefreshIcon />
              </IconBtnBase>
            </div>
          ),
        }}
        Section={
          <div className="mt-8">
            <Tabs
              value={version}
              onChange={(e, newValue) => {
                setVersion(newValue);
                setPage(1);
              }}
              aria-label="basic tabs example"
              centered
            >
              <Tab label="2025" value={4} />
              <Tab label="2024" value={3} />
              <Tab label="2023" value={2} />
              <Tab label="2022" value={1} />
            </Tabs>
            <Tabs
              value={awardParticipatCategories}
              onChange={(e, newValue) => {
                setAwardParticipatCategories(newValue);
                setPage(1);
              }}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="All"
                value={null}
                icon={
                  <span
                    style={{
                      backgroundColor: "rgb(229, 252, 242)",
                      borderRadius: 99,
                      padding: "3px 15px",
                    }}
                  >
                    {participationCount.data?.all ?? "--"}
                  </span>
                }
                iconPosition="bottom"
              />
              <Tab
                label="Individuals"
                value={"professional"}
                icon={
                  <span
                    style={{
                      backgroundColor: "rgb(229, 252, 242)",
                      borderRadius: 99,
                      padding: "3px 15px",
                    }}
                  >
                    {participationCount.data?.professional ?? "--"}
                  </span>
                }
                iconPosition="bottom"
              />
              <Tab
                label="Universities"
                value={"university"}
                icon={
                  <span
                    style={{
                      backgroundColor: "rgb(229, 252, 242)",
                      borderRadius: 99,
                      padding: "3px 15px",
                    }}
                  >
                    {participationCount.data?.university ?? "--"}
                  </span>
                }
                iconPosition="bottom"
              />
              <Tab
                label="Schools"
                value={"school"}
                icon={
                  <span
                    style={{
                      backgroundColor: "rgb(229, 252, 242)",
                      borderRadius: 99,
                      padding: "3px 15px",
                    }}
                  >
                    {participationCount.data?.school ?? "--"}
                  </span>
                }
                iconPosition="bottom"
              />
            </Tabs>
            <Box className="mt-8" sx={styles.tableSize}>
              <Grid container spacing={spacing}>
                <Grid item xs={12}>
                  <Paper>
                    <DataGrid
                      rowCount={paginator1}
                      pagination
                      paginationMode="server"
                      onPageChange={(newPage) => setPage(newPage + 1)}
                      loading={participationListRender?.isLoading}
                      rows={participationList}
                      columns={columns1}
                      pageSize={perPage}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </div>
        }
      />
      <ExportProgressModal
        open={showProgressModal}
        exportJobId={exportJobId}
        onClose={() => setShowProgressModal(false)}
        onComplete={handleExportComplete}
      />
    </>
  );
};
export default ParticipationsPage;
